<template>
	<div class="main">
		<header class="page-title">
			<h2>{{ data.name }}</h2>
		</header>
		<meta-tags-card
				:data-card-instance-id="data.id"
				:data-card-meta-seo-box="data.seoBox">
		</meta-tags-card>
	</div>
</template>

<script>
	import {eventBus} from "../../../app";

	export default {
		props: {
			data: {
				required: true
			}
		},
		created() {
			let vm = this;
			/* From MetaTagsCard */
			eventBus.$on('updateMetaTags', function (currentMetas) {
				axios.post('/api/' + vm.$selectedSite.slug + '/providers/' + vm.data.id + '/review/seo', currentMetas)
						.then(function (response) {
							vm.$toastr.success('Provider Review SEO updated.');
						})
						.catch(e => {
							vm.errors.record(e.response.data);
							vm.$toastr.error('Save Provider Review SEO changes failed.', 'Error');
						});
			})
		},
		beforeDestroy() {
			eventBus.$off('updateMetaTags');
		}
	}
</script>

<style scoped>

</style>
